<template>
  <div class="cs-courseHomeworkList">
    <el-row class="cs-courseHomeworkList-top">
      <el-col :span="4" v-if="courseType == 1">
        <el-select
          v-if="!USERMANAGER.isStudent"
          @change="getListData()"
          placeholder="学期"
          v-model="searchCondition.termId"
          size="medium"
        >
          <el-option
            v-for="item in termList"
            :key="item.Id"
            :label="item.DisplayLable"
            :value="item.Id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" v-if="courseType == 1 && (USERMANAGER.isAdmin || USERMANAGER.isEducationalAssistant || USERMANAGER.isAcademicDirector || USERMANAGER.isRegionCEO || USERMANAGER.isCampusPresident)">
        <el-select
          @change="getListData()"
          placeholder="请选择"
          size="medium"
          v-model="searchCondition.groupNumber"
          class="margin-left-20px"
        >
          <el-option
            v-for="item in universityGroups"
            :key="item.IdValue"
            :label="item.NameValue"
            :value="item.GroupNumber"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" v-if="courseType == 3">
        <el-select
          @change="changeCourseCategory()"
          placeholder="职业类型"
          size="medium"
          v-model="searchCondition.courseCategory"
        >
          <el-option
            v-for="item in courseCategories"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4" v-if="courseType == 3">
        <el-select
          v-if="!USERMANAGER.isStudent"
          @change="getListData()"
          placeholder="学期"
          v-model="searchCondition.termId"
          size="medium"
          class="margin-left-20px"
        >
          <el-option
            v-for="item in vocationalTrainingTermList"
            :key="item.Id"
            :label="item.DisplayLable"
            :value="item.Id"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="6" class="current-term-container" v-if="!!currentTerm">
        <span class="current-term">本学期：{{currentTerm.DisplayLable}}</span>
      </el-col>
      <el-col :span="10" v-if="!USERMANAGER.isStudent">
        <el-date-picker
          class="cs-courseHomeworkList-searchDate"
          v-model="searchDate"
          type="daterange"
          align="center"
          unlink-panels
          range-separator="-"
          start-placeholder="开始"
          end-placeholder="结束"
          :picker-options="pickerOptions"
          size="medium"
        ></el-date-picker>

        <el-button
          type="primary"
          v-loading="isDownloading"
          element-loading-text="下载中,请稍候"
          element-loading-spinner="el-icon-loading"
          :disabled="isDownloading"
          size="small"
          @click="onDownload"
        >一键下载</el-button>
      </el-col>
    </el-row>
    <pagination v-loading="loading" :data="listData" :option="paginationOption" @edit="onEdit"></pagination>
  </div>
</template>

<style lang="scss">
.cs-courseHomeworkList {
  /deep/ .el-loading-spinner{
    margin-top: -15px;
  }
  /deep/ .el-loading-spinner .el-loading-text {
    font-size: 12px;
  }
  .current-term-container {
    //display:table-cell;
    height: 36px;
  }
  .current-term {
    padding-left: 20px;
    vertical-align: middle;
    line-height: 36px;
  }
  .cs-courseHomeworkList-top {
    .el-button {
      vertical-align: middle;
    }
    .cs-courseHomeworkList-searchDate {
      width: 250px !important;
    }
  }
}
</style>

<script>
import {
  getUniversityGroups,
  getUniversityByGroup,
  getTerms,
  getTrainingCategoryList,
  getTrainingTerms,
  getCurrentTerm
} from "../../service/common.service";
import {
  getCourseHomeworkList,
  downloadHomework,
  getTotalFilesInfo 
} from "../../service/homework.service";
import pagination from "../common/pagination";
import { formatDate, downloadFile } from "../../config/mUtils";
import global_ from "@/core/global";

export default {
  data() {
    return {
      isDownloading: false,
      loading: false,
      listData: {},
      paginationOption: {},
      universityGroups: [],
      searchCondition: {
        groupNumber: "",
        termId: "",
        courseCategory: ""
      },
      searchDate: [],
      courseCategories: [],
      currentTerm: {},
      termList: [],
      vocationalTrainingTermList: [],
      pageSize: 20,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  components: {
    pagination
  },
  props: {
    courseType: Number
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: true,
      editButtonText: "查看",
      hasAddButton: false,
      addButtonText: "",
      hasSearch: false,
      editColumnTite: "详情查看",
      showAcitveColor: true,
      hideDisableRow: true,
      displayUniversityGroup: this.courseType == 1,
      displayCampus: this.courseType == 3,
      displayTeacher: !this.USERMANAGER.isStudent,
    };
    this.displayTerm = !this.USERMANAGER.isStudent;
    if (this.courseType == 1) {
      if (this.USERMANAGER.isStudent){
        getCurrentTerm().then(result => {
          if (!!result && result.success) {
            let list = [];
            list.push(result.data);
            this.termList =list;
            this.loadTerm(this.termList);
          } 
        });
      }else{
        getTerms(false, true).then(result => {
          if (!!result && result.success) {
            this.termList = result.data;
          
            this.loadTerm(this.termList);
          }
        });
      }
      if (this.USERMANAGER.isAdmin || this.USERMANAGER.isEducationalAssistant || this.USERMANAGER.isAcademicDirector || this.USERMANAGER.isRegionCEO || this.USERMANAGER.isCampusPresident){
        this.loadUniversityGroups(() => {
          this.setGroupNumber();
          this.getListData();
        });
      }else{
        this.searchCondition.groupNumber = -1;
      }
    } else if (this.courseType == 3) {
      getTrainingCategoryList(3, true).then(result => {
        if (!!result && result.success) {
          this.courseCategories = result.data;
          if (this.courseCategories.length > 0){
            this.searchCondition.courseCategory = this.courseCategories[0].Id;
            this.changeCourseCategory();
          }
        }
      });
    }

    this.searchDate = [];
    let today = new Date();
    this.searchDate.push(today);
    this.searchDate.push(today);
  },
  methods: {
    onEdit(index, row) {
      this.$router.push({
        path: "/homeworkList",
        query: {
          courseType: this.courseType,
          courseId: row.CourseId,
          campusId: row.CampusId,
          courseName: row.CourseName
        }
      });
    },
    setGroupNumber() {
      let groupNumber = this.$route.query.groupNumber;

      if (groupNumber && groupNumber > 0) {
        this.searchCondition.groupNumber = parseInt(groupNumber);
      } else {
        if (!!this.universityGroups && this.universityGroups.length > 0) {
          this.searchCondition.groupNumber = this.universityGroups[0].GroupNumber;
        }
      }
    },
    loadUniversityGroups(callback) {
      getUniversityGroups().then(result => {
        if (!!result && result.success) {
          this.universityGroups = result.data;
          if (!!callback) {
            callback();
          }
        }
      });
    },
    changeCourseCategory() {
      if (this.USERMANAGER.isStudent){
        getCurrentTerm(2, this.searchCondition.courseCategory).then(result => {
          if (!!result && result.success) {
            let list = [];
            list.push(result.data);
            this.termList =list;
            this.loadTerm(this.termList);
          } 
        });
      }else{
        getTrainingTerms(false, this.searchCondition.courseCategory, true).then(
          result => {
            if (!!result && result.success) {
              this.vocationalTrainingTermList = result.data;
              this.loadTerm(this.vocationalTrainingTermList);
            }
          }
        );
      }
    },
    loadTerm(terms){
      if (terms.length > 0){
        this.currentTerm = terms.find(i => i.IsCurrentTerm);
        if (!!this.currentTerm) {
          this.searchCondition.termId = this.currentTerm.Id;
        }else{
          this.searchCondition.termId = terms[0].Id;
        }
      }else{
        this.searchCondition.termId = "";
      }

      this.getListData();
    },
    getSearchPageData(isDownload) {
      let pageData = {
        pageNumber: 1
      };
      let additionalFilter = {
        CourseType: this.courseType,
        TermId: this.searchCondition.termId,
        GroupNumber: this.searchCondition.groupNumber
      };

      let startDate = "";
      let endDate = "";
      if (!!isDownload && !!this.searchDate && this.searchDate.length == 2) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }

      let searchData = {
        pageSize: this.pageSize,
        keyWord: "",
        additionalFilter: additionalFilter,
        startDate: startDate,
        endDate: endDate
      };

      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },
    getListData() {
      let pageData = this.getSearchPageData();
      this.loading = true;
      getCourseHomeworkList(pageData)
        .then(result => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async onDownload() {
      if (!this.searchCondition.termId) {
        return;
      }
      let pageData = this.getSearchPageData(true);

      let info = await getTotalFilesInfo(pageData);
      if (!info || !info.success) {
        let msg = "";
        if (!!info && !!info.message) {
          msg = info.message;
        } else {
          msg = "作业下载失败";
        }
        this.$message.error(msg);
        return;
      }

      let courseList = info.data.CourseList;
      if (courseList.length == 0) {
        this.$message({
          message: "选中的日期范围内没有任何作业文件可下载",
          type: "warning",
        });
        return;
      }

      this.isDownloading = true;
      if (info.data.IsSeperated) {
        for (let i = 0; i < courseList.length; i++) {
          this.$notify.closeAll();
          let item = courseList[i];
          this.$notify({
            title: "文件下载中",
            message: `文件总大小${info.data.TotalSizeText}，需分课程下载。共${
              courseList.length
            }个课程，正在下载第${i + 1}个课程(${item.Value})。`,
            duration: 0,
          });
         
          pageData.additionalFilter["CourseId"] = item.Key;

          let result = await downloadHomework(pageData);

          if (!!result && result.success) {
            downloadFile(result);
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
        }
        this.$notify.closeAll();
      } else {
        let result = await downloadHomework(pageData);

        if (!!result && result.success) {
          downloadFile(result);
        } else {
          if (!!result.message) {
            this.$message.error(result.message);
          }
        }
      }

      this.isDownloading = false;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/courseHomeworkList.vue